import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";

export default function PFAStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Denumire PFA" value={data.pfaDenumire} onChange={update("pfaDenumire")} placeholder="ex: Popescu Ion PFA" required error={errors.pfaDenumire} />
      <InputField label="CUI" value={data.pfaCUI} onChange={update("pfaCUI")} placeholder="ex: 12345678" required half error={errors.pfaCUI} />
      <InputField label="Sediu profesional" value={data.pfaSediu} onChange={update("pfaSediu")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.pfaSediu} />
      <InputField label="Numele titularului PFA" value={data.pfaTitular} onChange={update("pfaTitular")} placeholder="ex: Popescu Ion" required error={errors.pfaTitular} />
      <OptionalFields>
        <InputField label="CNP" value={data.pfaCNP} onChange={update("pfaCNP")} placeholder="ex: 1234567890123" half error={errors.pfaCNP} helperText="Opțional — poți completa de mână pe document" />
        <InputField label="Serie si nr. CI" value={data.pfaCI} onChange={update("pfaCI")} placeholder="ex: RD 123456" half error={errors.pfaCI} helperText="Opțional — poți completa de mână pe document" />
      </OptionalFields>
    </div>
  );
}
